export default {
	message: {
		common:
		{
			update_successfully: 'update successfully'
		},
		header:
		{
			Systemdoes:"System does not have configuration snapshot, please add a snapshot. ",
			alarm: 'New alarms',
			see_alarm: 'See all alarms',
			search: 'Search',
			user_name: 'User name',
			setting: 'Account setting',
			logout: 'Logout',
			logouts: 'logout',
			login: 'Login',
			API: "API",
			goto: "Go to download",
			control: "Please download and install the plugin",
			Reboot: "Reboot"
		},
		left:
		{
			VIDEO: 'VIDEO PLATFORM CONTROL CENTER',
			Control: "Control Center",
			navigation: 'Navigation',
			dashboard: 'Dashboard',
			live: 'Live',
			playback: 'Playback',
			AdvancePB: 'AdvancePB',
			archive: "Archive",
			screenshots: "Folder",
			event: "Event",
			snapshot: 'Snapshot',
			setting: 'Setting',
			cloud: 'Cloud',
			logout: 'Logout',
			tour: "Tour",
			camera: "Camera",
			VideoConference: "Video Conference",
			MapManagement:"Map Management",
			Map:"Map"
		},
		login:
		{
			high_perf: 'High performance HTML5 native video',
			signin: 'Sign In to Admin',
			login: 'LOG IN',
			login_status_failed: 'Username or Password not correct',
			username: 'USERNAME',
			password: 'PASSWORD',
			language: 'LANGUAGE',
			return: "Return"

		},
		dashboard:
		{
			Storage: "Storage",
			Copysuccessful: "Copy successful",
			about: "	About",
			dashboard: 'Dashboard',
			system_info: 'System Info',
			version: 'Version',
			hostid: 'Hostid',
			license: 'License',
			channel: 'Channel',
			endtime: 'Endtime',
			memory: 'Memory',
			running: 'Running',
			network_in: 'Network In',
			network_out: 'Network Out',
			an_out: "Network in and out",
			free_space: "Free Space",
			online_cam: "Online Cameras",
			cameras: "Cameras",
			total_space: "Total Space",
			codec_info: "Codec Info",
			GPU_info: "GPU info",
			cpumodel: 'CPU Model',
			gpuencoder: "GPU Encoders",
			gpudecoder: "GPU Decoders",
			PhysicalCPU: "Physical CPU",
			CPUCore: "CPU Core",
			cpuencoder: "Software Encoders",
			cpudecoder: "Software Decoders",
			capability: "Capability",
			devicesdk: "Device SDK",
			device: "Device",
			gb28181: "GB28181",
			devicesdkpb: "Device SDK Playback",
			transcoding: "Transcoding",
			Lingvideo: "Lingvideo",
			Docker: "Docker",
			VideoConference: "Video Conference",
			cluster: "Cluster",
			Online: "Online",
			Not_nline: "Not_nline",
			Platform: "Platform",
			Hikvision: "Hikvision",
			Dahua: "Dahua",
			Uniview: "Uniview",
			Tiandy: "Tiandy",
			DiskMemory: "Disk/Memory",
			TotalMemory: "Total Memory",
			total: "Total ",
			ge: "",
			Cloud: "Cloud",
			RTMP: "RTMP push",
			Online: "Online",
			Offline: "Offline",
			Editorfailure: "Editor failure"
		},
		live:
		{
			View:'View',
			NewView:'New View',
			ViewName:'View Name',

			LightON: "Light ON",
			LightOFF: "Light OFF",
			WiperON: "Wiper ON",
			WiperOFF: "Wiper OFF",
			focusing: "Focusing",
			Focus: "Focus",
			aperture: "Aperture",
			liveview: 'Liveview',
			device: 'DEVICE',
			setting: 'SETTING',
			protocol: 'PROTOCOL',
			mainstream: 'Main Stream',
			substream: 'Sub Stream',
			camera: "Camera",
			waterprint: "Watermark",
			Videorecording: "Video recording",
			Region: "Region",
			Scan: "Scan to view video",
			Quality: "Quality",
			Switched: "Switched",

			Video: "Video",
			Codec: "Codec",
			Width: "Width",
			Height: "Height",
			FPS: "FPS",
			Bitrate: "Bitrate",

			Audio: "Audio",
			Codec: "Codec",
			SampleRate: "SampleRate",
			SampleBit: "SampleBit",
			Channels: "Channels",
			Bitrate: "Bitrate",
		},
		setting:
		{
			LoadAllChannel:'Load All Channel',
			Sandbox:"Sandbox",

			ClientConfiguration:"Client Configuration",
			Domainlist:"Domain list",
			ForceHTTPS:"Force HTTPS",
			EnableDomain:"Enable Domain",
			DocumentRoot:"Document Root",

			RTCENGINE:"RTC Engine",

			RTSPRTMP:"RTSP/RTMP",
			ONVIF:"ONVIF",
			File:"File",
			Stremlang:'sub URL',

			Audio: "Audio",
			DeviceImport:"Device Import", 
			Import:"Import",
			Batchimportdevice:"Batch import device",
			Cancel: "Cancel",


			Default: "Default",
			Transcoding: "Transcoding",
			Profile: "Profile",
			setting: 'SETTING',
			device: 'Device',
			record: 'Record',
			devicesdk: 'Device SDK',
			devicertmppush: 'RTMP Push',
			Regional: "Region",
			Area: "Edit",
			Please: "Please enter a name",
			Input: "Input box cannot be empty",

			user: 'User',
			role: 'Role',
			action: 'Action',
			edit: 'Edit',
			name: 'Name',

			Authority: "Authority",
			username: "User Name",
			Rolemanagement: "Role",
			SystemManagement: "System",
			CyberSecurity: "CyberSecurity",
			password: "Password",
			RoleName: "Role Name",
			Configure: "Configure",
			Operation: " Operate ",
			Camera: "Camera Permissions",
			Watchvideo: "View Anonymously",

			CloudConnect: "Cloud Connect",
			SSL: "SSL",
			KeepaliveTime: "KeepaliveTime",
			Enable: "Enable",
			EdgeTranscoding: "EdgeTranscoding",

			//日志
			Log: 'Log',
			LogLevel: 'Log Level',
			LogRotating: 'Log Rotating',
			System: 'System',
			Snopshot: 'Snopshot',
			SnapshotList: 'Snapshot List',
			Name: 'Name',
			Refresh: 'Refresh',
			Protocol: 'Protocol',
			ServiceDetection: 'RTSP Service Detection',

			CloudMode: 'Cloud Mode',
			RelayMode: "Relay Mode",
			TURNServer: "TURN Server",
			PublicIP: "Public IP",
			MinPort: "Min Port",
			MaxPort: "Max Port",
			PasswordEncrypt: "PasswordEncrypt",

			currentpass: 'Current Password',
			newpass: 'New Password',
			confirmpass: 'Repeat New Password',
			confirmpassword: 'Repeat The Password',
			manualstart: "Manual Start Record All Channel ",
			manualstop: "Manual Stop Record All Channel",
			DeleteAll: "Delete",
			Detail: "Detail",
			Cancel: "Cancel",
			OK: "OK",
			Configuration: "Configuration",
			ADD: "Add",
			Change: "Change",
			Changecg: "Change successfully, please login again！",
			Changesb: "Change failed",
			Twopassword: "Two password are not same, please check!",
			all: "All",
			Creationfailed: "Creation failed",
			Illegal: "Illegal login lock"
		},
		table: {
			pleasechoose: "please choose",
			Enterkeywords: "Enter keywords",
			Token: "Token",
			Type: "Type",
			Online: "Online",
			Edit: "Edit",
			Index: "Index",
			GBID: "GBID",
			IP: "IP",
			Name: "Name",
			Port: "Port",
			User: "User",
			UUID: "UUID",
			Time: "Time",
			Detaill: "Detaill",
			Tokenevent: "Token",
			StartTime: "Start Time",
			EndTime: "End Time",
			Codec: "Codec",
			Engine: "Engine",
			FPSType: "FPSType",
			ScaleType: "ScaleType",
			Bitrate: "Bitrate",
			FPS: "FPS",
			WH: "Width*Height"
		},
		playback: {
			H5SPlayback: "H5S Playback",
			NVRPlayback: "NVR Playback"
		},
		GB: {
			GB28181: "Down Level Domain",
			GBPlatform: "Up Level Domain",
			GBService: "GB Service",
			main:'main',
			sub:'sub',


			name: 'Name',
			// GB28181:"GB28181",
			// GBPlatform:"GB Platform",
			Name: "Name",
			SIPServerIP: "SIP Server IP",
			SIPServerPort: "SIP Server Port",
			SIPPort: "SIP Port",
			SIPUserID: "SIP User ID",
			SIPServerID: "SIP Server ID",
			Password: "Password",
			SIPProtocol: "SIP Protocol",
			SIPChannelBaseID: "SIP Channel BaseID",
			RegisterPeriod: "Register Period",
			KeepaliveTime: "Keepalive Time",
			Domain: "Domain",
			Refreshsuccess: "Refresh success",
			Restartsuccessfully: "Restart successfully",
			//service
			GbID: "GbID",
			GbServerIpAddr: "GbServerIpAddr",
			GbServerPort: "GbServerPort",
			PortRangeMin: "PortRangeMin",
			PortRangeMax: "PortRangeMax",
			GbStreamProto: "GbStreamProto",
			GbServerProto: "GbServerProto",
			GbTimeout: "GbTimeout",
			Password: "Password",
			Realm: "Realm",
			SubAlarm: "SubAlarm",
			SubMobilePosition: "SubMobilePosition",
			Enable: "Enable",
			EnableAudio: "EnableAudio",
			EnableSSRCCheck: "EnableSSRCCheck",

			Stream:"Stream",

			DeleteAll: "DeleteAll",
			Detail: "Detail",
			Cancel: "Cancel",
			OK: "OK",
			Configuration: "Configuration",
			OVER: "OVER",
			ADD: "ADD",
			edit: 'Edit'

		},
		archive: {
			search: 'Search',
			archive: 'Archive',
			StartTime: "Start Time",
			EndTime: "End Time",
			ManualRecord: "Manual Record",
			AlarmRecord: "Alarm Record",
			Schedulerecord: "Schedule record",
			Refresh: "Refresh",
			Download: "Download",
			Playback: "Playback",
			Name: "Name",
			Clear: "Clear",
			snapshot: 'Snapshot',
			Onehour: "One hour",
			Oneday: "One day",
			Oneweek: "One week",
			Onemonth: "One month",
			Time: "Time",
			Preview: "Preview",
			Picture: "Picture",
			Pleaseselectone: "Please select one"
		},
		tour: {
			Start: "Start",
			stop: "Stop",
			Startall:'Start all'
		},
		camera: {
			Save_successfully: "Save successfully!",
			// Editor_failure:"Editorial_success!",
			Delete_successful: "Delete_successful!",
			Delete_failed: "Delete_successful！",
			open_Close: "Enable/Disable",
			name: 'Name',
			audio: "Audio",
			save: "Save"
		},
		Conference: {
			Upload: "Upload",
			Videointercom: "Video Intercom",
			VideoConference: "Video Conference",
			Connect: "Connect",
			Disconnect: "Disconnect",
			Call: "Call",
			VideoCall: "Video Call",
			AudioCall: "Audio Call",
			HangUp: "Hang Up",
			Hang: "Hang",
			JoinConference: "Join Conference",
			Nickname: "Nickname cannot be empty!"
		},
		cluster:{
			NodeName:'Node Name',
			NodeID:"Node ID",
			RedisServerIP:"Redis Server IP",
			RedisServerPort:"Redis Server Port",
			LocalIP:"Local IP",
			PleaseHTTP:"Please enable HTTP domain !"
		}
	}
}
